import React from 'react'
import { Button, Select } from 'antd'
import { PrinterOutlined } from '@ant-design/icons'
import palletSticker from '../../static/pdf/pallet-stickers/pallet-sticker'

interface PalletFilterPrintBarProps {
  /** 当前数据中出现的托盘号 */
  pallets: string[]
  /** 选中的托盘号（用于过滤与单个打印） */
  value?: string | null
  onChange: (pallet: string | null) => void
  /** 右侧统计信息 */
  info?: string
}

/**
 * 区域对话框顶部的托盘筛选 + 打印工具条：
 * - 托盘多时可通过下拉搜索快速定位托盘（表格按所选托盘过滤）
 * - 支持打印所选托盘标签，或一键打印全部托盘标签
 */
const PalletFilterPrintBar = (props: PalletFilterPrintBarProps) => {
  const validPallets = Array.from(new Set(props.pallets.filter(Boolean)))

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12, flexWrap: 'wrap' }}>
      <span style={{ fontWeight: 500 }}>Pallet:</span>
      <Select
        showSearch
        allowClear
        placeholder="Search pallet to filter / print"
        style={{ minWidth: 260 }}
        value={props.value ?? undefined}
        onChange={(v: any) => props.onChange(v ?? null)}
        optionFilterProp="value"
        options={validPallets.map((pallet) => ({ value: pallet, label: pallet }))}
      />
      {props.info && <span style={{ color: '#888', fontSize: 12 }}>{props.info}</span>}
      <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
        <Button
          icon={<PrinterOutlined />}
          disabled={!props.value}
          onClick={() => palletSticker([props.value as string], 'print')}
        >
          Print Pallet
        </Button>
        <Button
          disabled={validPallets.length === 0}
          onClick={() => palletSticker(validPallets, 'print')}
        >
          Print All ({validPallets.length})
        </Button>
      </div>
    </div>
  )
}

export default PalletFilterPrintBar
